export const JACKET_DEFAULT_MEASUREMENTS = {
  bellyProfile: 'normal',
  posture: 'normal',
  neck: 15,
  chest: 40,
  waist: 36,
  belly: 38,
  seat: 40,
  shoulder: 18,
  armholeScyeDepth: 9,
  acrossBack: 17,
  acrossFront: 16,
  jacketLengthBack: 30,
  jacketLengthFront: 30,
  jacketSleeveLength: 25.5,
  jacketSleeveCapEase: 1,
  jacketSleeveBicep: 15,
  jacketSleeveElbow: 13,
  jacketSleeveHem: 11,
  sleeveFrontPitchPercent: 0.7,
  sleeveBackPitchPercent: 0.35,
  sleeveDistToElbow: 0,
  sleevePitchShift: 0,
  sleevePitchRotation: 0,
  topSleeveEasePercent: 100,
  underSleeveEasePercent: 0,

  chestEase: 2,
  waistEase: 1.5,
  bellyEase: 1.75,
  seatEase: 2,

  overrideFNWEnabled: false,
  overrideBNWEnabled: false,
  overrideFNDEnabled: false,
  overrideBNDEnabled: false,
  overrideFNW: 3,
  overrideBNW: 3,
  overrideFND: 3,
  overrideBND: 0.75,

  backShoulderSlope: 2.25,
  frontShoulderSlope: 2.25,
  backToFtHps: 0.5,

  distanceToWaist: 17.5,
  distanceToBelly: 5,

  overrideAcrossBackDepthEnabled: false,
  overrideAcrossFrontDepthEnabled: false,
  overrideAcrossBackDepth: 0,
  overrideAcrossFrontDepth: 0,

  fishDartEnabled: true,
  jacketDartMode: 'belly_and_fish',
  dartWidthWaist: 0.5,
  dartWidthBelly: 0.5,
  dartLengthTop: 5,
  dartLengthBottom: 4,
  dartWaistShift: 0,

  chestPocketEnabled: true,
  chestPocketWidth: 4,
  chestPocketDepth: 0.875,
  chestPocketAboveChest: 0.5,
  chestPocketArmholeLift: 0.25,
  sidePocketEnabled: false,
  sidePocketLength: 6,
  sidePocketStartOffset: 0.5,

  jacketButtonLayout: 'two_buttons',
  jacketLowerButtonDistance: 4.25,
  jacketUpperButtonDistance: 4.25,
  jacketButtonEdgeOffset: 0.5,
  jacketButtonholeLength: 0.75,

  jacketFrontClosure: 'single_breasted',
  lapelType: 'pointed_notch',
  lapelWidth: 3.5,
  gorgePointDepth: 5,

  backChestBalanceDx: 0,
  frontChestBalanceDx: 0,
  backWaistBalanceDx: 0,
  frontWaistBalanceDx: 0,
  backBellyBalanceDx: 0,
  frontBellyBalanceDx: 0,
  backSeatBalanceDx: 0,
  frontSeatBalanceDx: 0,

  jacketCb4Dx: 0,
  jacketCb4Dy: 0,
  jacketBlpsDx: 0,
  jacketBlpsDy: 0,
  jacketBxbDx: 0,
  jacketBxbDy: 0,
  jacketFlpsDx: 0,
  jacketFlpsDy: 0,
  jacketFxfDx: 0,
  jacketFxfDy: 0,
  jacketBwpsDx: 0,
  jacketBwpsDy: 0,
  jacketFwpsDx: 0,
  jacketFwpsDy: 0,
  jacketBbpsDx: 0,
  jacketBbpsDy: 0,
  jacketFbpsDx: 0,
  jacketFbpsDy: 0,
  jacketBspsDx: 0,
  jacketBspsDy: 0,
  jacketFspsDx: 0,
  jacketFspsDy: 0,
  jacketCpoDx: 0,
  jacketCpoDy: 0,
  jacketSp1Dx: 0,
  jacketSp1Dy: 0,

  jacketCb5Dx: 0,
  jacketCb6Dx: 0,
  jacketCb7Dx: 0,
  jacketBahpDx: 0,
  jacketBahpDy: 0,
  jacketRl1Dx: 0,
  jacketRl1Dy: 0,
  jacketLp1Dx: 0,
  jacketLp1Dy: 0,
  jacketLp0Dx: 0,
  jacketLp0Dy: 0,
  jacketLapelFallCurveCtrlDx: 0,
  jacketLapelFallCurveCtrlDy: 0,
  jacketRoundedNotchCurveCtrlDx: 0,
  jacketRoundedNotchCurveCtrlDy: 0,
  jacketRoundedNotchCollarCurveCtrlDx: 0,
  jacketRoundedNotchCollarCurveCtrlDy: 0,
  jacketPeakLapelFallCurveCtrlDx: 0,
  jacketPeakLapelFallCurveCtrlDy: 0,
  shawlTcol2Lp0CtrlDx: 1,
  shawlTcol2Lp0CtrlDy: 1.5,
  shawlLp0Rl1CtrlDx: 4,
  shawlLp0Rl1CtrlDy: 4,
  jacketRl2Dx: 0,
  jacketRl2Dy: 0,
  diamondShawlTcol2Rl2CtrlDx: 0,
  diamondShawlTcol2Rl2CtrlDy: 0,
  jacketLboDx: 0,
  jacketLboDy: 0,

  jacketScpbDx: 0,
  jacketScpfDx: 0,
  jacketSwpbDx: 0,
  jacketSwpfDx: 0,
  jacketSbpbDx: 0,
  jacketSbpfDx: 0,
  jacketSspbDx: 0,
  jacketSspfDx: 0,
  jacketSahpDx: 0,
  jacketSahpDy: 0,

  frontNeckCtrlDx: -0.75,
  frontNeckCtrlDy: 1.25,
  frontShoulderCurveCtrlDx: 0,
  frontShoulderCurveCtrlDy: 0,
  backShoulderCurveCtrlDx: 0,
  backShoulderCurveCtrlDy: 0,
  underCollarCurveStartCtrlDx: -1,
  underCollarCurveStartCtrlDy: 2.75,
  underCollarCurveEndCtrlDx: -2.625,
  underCollarCurveEndCtrlDy: -3.25,
  topCollarCurveStartCtrlDx: 0,
  topCollarCurveStartCtrlDy: 0,
  topCollarCurveEndCtrlDx: -1.75,
  topCollarCurveEndCtrlDy: -2,
  jacketSleeveFrontUnderarmCtrlDx: 1,
  jacketSleeveFrontUnderarmCtrlDy: -2,
  jacketSleeveFrontCrownCtrlDx: 0.375,
  jacketSleeveFrontCrownCtrlDy: -1.75,
  jacketSleeveBackCrownCtrlDx: -0.25,
  jacketSleeveBackCrownCtrlDy: -1.25,
  jacketSleeveBackUnderarmCtrlDx: -0.375,
  jacketSleeveBackUnderarmCtrlDy: 0.25,
  jacketSleeveBackSeamUpperCtrlDx: -0.5,
  jacketSleeveBackSeamUpperCtrlDy: 0,
  jacketSleeveBackSeamLowerCtrlDx: -0.25,
  jacketSleeveBackSeamLowerCtrlDy: 0,
  jacketSleeveTopSeamUpperCtrlDx: -0.5,
  jacketSleeveTopSeamUpperCtrlDy: 0,
  jacketSleeveTopSeamLowerCtrlDx: -0.25,
  jacketSleeveTopSeamLowerCtrlDy: 0,
  jacketSleeveUnderSeamUpperCtrlDx: -0.5,
  jacketSleeveUnderSeamUpperCtrlDy: 0,
  jacketSleeveUnderSeamLowerCtrlDx: -0.25,
  jacketSleeveUnderSeamLowerCtrlDy: 0,
  frontArmPart1CtrlDx: 0,
  frontArmPart1CtrlDy: 0,
  frontArmPart2CtrlDx: 1,
  frontArmPart2CtrlDy: 1.25,
  frontChestWaistCtrlDx: 0.25,
  frontChestWaistCtrlDy: 0,
  frontWaistBellyCtrlDx: 0,
  frontWaistBellyCtrlDy: 0,
  frontBellySeatCtrlDx: 0,
  frontBellySeatCtrlDy: 0,
  frontJacketHemCurveCtrlDx: 1.5,
  frontJacketHemCurveCtrlDy: 4.5,

  backChestWaistCtrlDx: 0,
  backChestWaistCtrlDy: 0,
  backArmPart1CtrlDx: 0,
  backArmPart1CtrlDy: 0,
  backArmPart2CtrlDx: 0,
  backArmPart2CtrlDy: 0,
  backWaistBellyCtrlDx: 0,
  backWaistBellyCtrlDy: 0,
  backBellySeatCtrlDx: 0,
  backBellySeatCtrlDy: 0,

  sideFrontArmCtrlDx: -0.75,
  sideFrontArmCtrlDy: 1.375,
  sideBackArmCtrlDx: -0.125,
  sideBackArmCtrlDy: 0,
  sideFrontChestWaistCtrlDx: -0.375,
  sideFrontChestWaistCtrlDy: 0,
  sideFrontWaistBellyCtrlDx: 0,
  sideFrontWaistBellyCtrlDy: 0,
  sideFrontBellySeatCtrlDx: 0.125,
  sideFrontBellySeatCtrlDy: 0,
  sideBackChestWaistCtrlDx: 0,
  sideBackChestWaistCtrlDy: 0,
  sideBackWaistBellyCtrlDx: 0.125,
  sideBackWaistBellyCtrlDy: 0,
  sideBackBellySeatCtrlDx: -0.25,
  sideBackBellySeatCtrlDy: 0,
};
